import React, { memo } from "react";

const Label = ({
  className,
  children,
  isRequired = false,
  htmlFor = "",
  ...props
}) => {
  return (
    <label className={`${className}`} htmlFor={htmlFor} {...props}>
      {children}
      {isRequired ? <span className="text-danger">*</span> : ""}
    </label>
  );
};

export default memo(Label);
